import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-update-partner',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './update-partner.component.html',
  styleUrl: './update-partner.component.scss',
})
export class UpdatePartnerComponent implements OnInit {
  error?: string;
  form!: FormGroup;
  submitting: boolean = false;

  constructor(
    private fb: FormBuilder,
    private partnerService: PartnerService,
    private authService: AuthenticationService,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      id: fb.control(null),
      name: fb.control('', Validators.required),
      address: fb.control('', Validators.required),
      city: fb.control('', Validators.required),
      pib: fb.control('', Validators.required),
      phone: fb.control(null),
      email: fb.control(null),
      active: fb.control(true, Validators.required),
    });
  }

  ngOnInit(): void {
    let partnerRaw = localStorage.getItem('edit');

    if (partnerRaw == null) {
      this.router.navigateByUrl('dashboard/partners');
    } else {
      localStorage.removeItem('edit');
      let partner = JSON.parse(partnerRaw);
      this.form.setValue(partner);
      this.form.controls['active'].setValue(partner.active == 1);
    }
  }

  updatePartner() {
    if (this.form.valid) {
      this.error = undefined;
      this.submitting = true;

      this.partnerService
        .updatePartner(this.form.value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            console.log(this.form.value);
            this.submitting = false;

            this.router.navigateByUrl('dashboard/partners');
          },
          error: (err: HttpErrorResponse) => {
            if (err.status == 401) {
              this.authService.logout();
            } else {
              this.submitting = false;
              this.error = err.error.message;
            }
          },
        });
    } else {
      this.error = 'Please fill all field properly.';
    }
  }
}
